export const routes = {
  subscription: {
    index: '/cancel-subscription',
    reason: '/cancel-subscription/reason',
    confirmation: '/cancel-subscription/confirm',
    success: '/cancel-subscription/success',
  },
  early: {
    wv: {
      index: '/wv/close-account/early',
      accountSelection: '/wv/close-account/early/acccount-selection',
      success: '/wv/close-account/early/success',
    },
    index: '/close-account/early',
    accountSelection: '/close-account/early/acccount-selection',
    success: '/close-account/early/success',
  },
  spend: {
    index: '/close-account/spend',
    confirmation: '/close-acccount/spend/confirm',
    success: '/close-account/spend/success',
  },
  later: {
    index: '/close-account/later',
    confirmation: '/close-account/later/confirm',
    success: '/close-account/later/success',
  },
}
